import React from "react";
import { MapPin, ExternalLink, MessageCircle } from "lucide-react";
import { useI18n } from "../lib/i18n";
import { TYPE_META } from "../lib/constants";

export default function AccommodationCard({ acc }) {
  const { t, lang } = useI18n();
  const meta = TYPE_META[acc.type] || TYPE_META.hostel;
  const desc = (lang === "fr" ? acc.description_fr : acc.description_en) || "";
  const cover = (acc.images && acc.images[0]) || meta.fallback || "https://images.unsplash.com/photo-1714561690635-6430252d9502?w=1200";

  return (
    <article data-testid={`acc-card-${acc.id}`} className="group bg-white rounded-3xl overflow-hidden border border-sand-300/70 hover:shadow-xl transition-all duration-500">
      <div className="relative overflow-hidden h-72" style={{ background: meta.bgSoft }}>
        <img src={cover} alt={acc.name} className="w-full h-full object-cover arch-shape transition-transform duration-700 group-hover:scale-105" />
        <span className="absolute top-4 left-4 px-3 py-1 rounded-full text-xs font-medium text-white shadow-sm" style={{ background: meta.color }}>
          {t.stays[`filter${acc.type === "guest_house" ? "Guest" : acc.type === "apartment" ? "Apartment" : "Hostel"}`]}
        </span>
      </div>
      <div className="p-7">
        <h3 className="font-serif text-2xl tracking-tight mb-2">{acc.name}</h3>
        {acc.location_name && (
          <a href={acc.google_maps_url || "#"} target="_blank" rel="noreferrer" data-testid={`acc-location-${acc.id}`}
             className="inline-flex items-center gap-1.5 text-sm text-wostel-ink/60 hover:text-wostel-cyan mb-4">
            <MapPin size={14} /> {acc.location_name}
          </a>
        )}
        {desc && <p className="text-sm leading-relaxed text-wostel-ink/70 mb-5 line-clamp-3">{desc}</p>}
        <div className="flex flex-col sm:flex-row gap-2">
          {acc.hostelworld_url && (
            <a href={acc.hostelworld_url} target="_blank" rel="noreferrer" data-testid={`acc-hostelworld-${acc.id}`}
               className="btn-pill flex-1 text-sm bg-wostel-ink text-sand-50 hover:bg-wostel-cyan">
              <ExternalLink size={14} /> {t.stays.bookHostelworld}
            </a>
          )}
          {acc.whatsapp_url && (
            <a href={acc.whatsapp_url} target="_blank" rel="noreferrer" data-testid={`acc-whatsapp-${acc.id}`}
               className="btn-pill flex-1 text-sm bg-wostel-sun text-wostel-ink hover:brightness-95">
              <MessageCircle size={14} /> {t.stays.bookWhatsapp}
            </a>
          )}
        </div>
      </div>
    </article>
  );
}
